import { createApp, h } from "vue";
import Alert from "@/components/UI/PopupAlert.vue";

function showAlert(text) {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        document.body.appendChild(container);

        const app = createApp({
            render() {
                return h(Alert, {
                    text,
                    showCancel: false,
                    onClose: (result) => {
                        app.unmount();
                        document.body.removeChild(container);
                        resolve(); // 使用者點了「確定」
                    },
                });
            },
        });

        app.mount(container);
    });
}

function showConfirm(text) {
    return new Promise((resolve) => {
        const container = document.createElement("div");
        document.body.appendChild(container);

        const app = createApp({
            render() {
                return h(Alert, {
                    text,
                    showCancel: true,
                    onClose: (result) => {
                        app.unmount();
                        document.body.removeChild(container);
                        resolve(result); // result=true使用者點了「確定」 result=false「取消」
                    },
                });
            },
        });

        app.mount(container);
    });
}

export default {
    install(app) {
        app.config.globalProperties.$popAlert = showAlert;
        app.config.globalProperties.$popConfirm = showConfirm;
        window.$popAlert = showAlert;
        window.$popConfirm = showConfirm;
    },
};
